import { render, staticRenderFns } from "./Environment.vue?vue&type=template&id=13d9148d&scoped=true&"
import script from "./Environment.vue?vue&type=script&lang=ts&"
export * from "./Environment.vue?vue&type=script&lang=ts&"
import style0 from "./Environment.vue?vue&type=style&index=0&id=13d9148d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d9148d",
  null
  
)

export default component.exports